<template>
  <v-row
    v-if="room && featuresField && room[featuresField] && Object.keys(room[featuresField]).length > 0"
    class="object-features"
    no-gutters
  >
    <v-col
      cols="12"
      class="pt-3 pb-1"
    >
      <h3>{{ title }} {{ room.number }}</h3>
    </v-col>
    <template
      v-for="featureId in Object.keys(room[featuresField]).filter(featureId => {
        return featuresList[featureId] && room[featuresField][featureId].checked === true
        })"
    >
      <v-col
        :key="featureId + '_quantity'"
        cols="1"
        class="text-right pr-1"
      >
        <template v-if="room[featuresField][featureId].quantity">
          {{ room[featuresField][featureId].quantity }} x
        </template>
      </v-col>
      <v-col
        cols="1"
        :key="featureId + '_icon'"
        class="text-center"
      >
        <v-icon small >
          {{ featuresList[featureId].icon }}
        </v-icon>
      </v-col>
      <v-col
        cols="10"
        :key="featureId + '_name'"
      >
        {{ capitalize(featuresList[featureId]['name_' + lang]) +
        (room[featuresField][featureId].distance
          ? ': ' + room[featuresField][featureId].distance
          : '') }}
      </v-col>
    </template>
  </v-row>
</template>

<script>
import sharedMethods from '../../methods/sharedMethods'
import { createHelpers } from 'vuex-map-fields'
import state from '../../store/state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'ObjectRoomFeatures',

  props: {
    featuresField: {
      type: String,
      default: null
    },
    room: {
      type: Object,
      default: () => {
        return {}
      }
    },
    title: {
      type: String,
      default: null
    }
  },

  computed: {
    ...mapFields(Object.keys(state))
  },

  methods: {
    ...sharedMethods
  }
}
</script>
